/**
 * Canonical player ESN label shared by Studio, on-device status overlay, Sentry `player_id_prefix`,
 * and playerOps (`#androidIdPrefix` on Android when known; otherwise player id prefix).
 */

export type TPlayerEsnDisplayInput = {
  playerId: string
  platform?: string | null
  androidIdPrefix?: string | null
}

/**
 * ESN token without `#` (for Sentry tags / lookups). Null when there is no usable id.
 * Android + `androidIdPrefix` → that prefix; else first UUID segment, or full undashed id.
 */
export function playerEsnToken(input: TPlayerEsnDisplayInput): string | null {
  const id = typeof input.playerId === 'string' ? input.playerId.trim() : ''
  const plat = (input.platform ?? '').toLowerCase()
  const prefix = typeof input.androidIdPrefix === 'string' ? input.androidIdPrefix.trim() : ''
  if (plat === 'android' && prefix !== '') {
    return prefix
  }
  if (id === '') {
    return null
  }
  return id.includes('-') ? (id.split('-')[0] ?? id) : id
}

/** Operator-facing ESN including leading `#`, or `—` when empty. */
export function formatPlayerEsnDisplay(input: TPlayerEsnDisplayInput): string {
  const token = playerEsnToken(input)
  return token == null ? '—' : `#${token}`
}
